import {
  canShowSketchPropertySection,
  registerPropertyManagerSection,
} from '@/core';
import SketchCircularPatternPropertySection from '@/components/editor/property-manager/sketch-circular-pattern/SketchCircularPatternPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-circular-pattern',
  title: '圆周阵列',
  order: 21,
  component: SketchCircularPatternPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: () => false,
  isApplicable: (context) => canShowSketchPropertySection(
    context,
    context.isSketchActive
      && context.activeCommand === 'sketch-circular-pattern'
      && context.renderer?.getSketchCircularPatternSnapshot?.()?.active === true,
  ),
  onConfirm: (context) => {
    context.onConfirm?.();
  },
  onCancel: (context) => {
    context.onCancel?.();
  },
});
